
export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="bg-gray-900 rounded-[40px] p-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
            <div className="md:col-span-1">
              <h3 className="text-5xl font-extralight text-white mb-8">Get in Touch</h3>
              <p className="text-gray-400 leading-relaxed font-light">
                Have questions about our products? We're here to help and answer any questions you might have.
              </p>
            </div>

            <div className="md:col-span-1">
              <h4 className="text-xs uppercase tracking-wider text-gray-500 mb-6 font-light">QUICK LINKS</h4>
              <div className="space-y-4">
                {['Products', 'Technology', 'About Us', 'Contact'].map((link) => (
                  <a
                    key={link}
                    href={`#${link.toLowerCase().replace(' ', '-')}`}
                    className="block text-white text-base hover:text-blue-400 transition-colors cursor-pointer font-light"
                  >
                    {link}
                  </a>
                ))}
              </div>
            </div>

            <div className="md:col-span-1">
              <h4 className="text-xs uppercase tracking-wider text-gray-500 mb-6 font-light">CONTACT</h4>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <i className="ri-phone-line text-blue-400 text-xl"></i>
                  <a href="tel:+16162131659" className="text-white text-base hover:text-blue-400 transition-colors cursor-pointer font-light">
                    +1 6162131659
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-mail-line text-blue-400 text-xl"></i>
                  <a href="mailto:help@gurtenshpk.com" className="text-white text-base hover:text-blue-400 transition-colors cursor-pointer font-light">
                    help@gurtenshpk.com
                  </a>
                </div>
                
                <div className="pt-6">
                  <h5 className="text-xs uppercase tracking-wider text-gray-500 mb-4 font-light">LOCATION</h5>
                  <div className="space-y-2 text-gray-400 text-sm font-light">
                    <p className="flex items-start space-x-3">
                      <i className="ri-map-pin-line text-blue-400 text-lg mt-0.5"></i>
                      <span>Rruga e Kavajes, Ndertesa Nr. 50</span>
                    </p>
                    <p className="flex items-start space-x-3">
                      <i className="ri-building-line text-blue-400 text-lg mt-0.5"></i>
                      <span>City TIRANE</span>
                    </p>
                    <p className="flex items-start space-x-3">
                      <i className="ri-mail-send-line text-blue-400 text-lg mt-0.5"></i>
                      <span>Zip 1000</span>
                    </p>
                    <p className="flex items-start space-x-3">
                      <i className="ri-global-line text-blue-400 text-lg mt-0.5"></i>
                      <span>Country Albania</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex space-x-6">
              <a href="#" className="text-white text-xs hover:text-blue-400 transition-colors cursor-pointer font-light">
                LinkedIn
              </a>
              <a href="#" className="text-white text-xs hover:text-blue-400 transition-colors cursor-pointer font-light">
                Twitter
              </a>
              <a href="#" className="text-white text-xs hover:text-blue-400 transition-colors cursor-pointer font-light">
                GitHub
              </a>
            </div>
            
            <p className="text-gray-500 text-xs font-light">
              © 2025 GURTEN SH.P.K. All rights reserved
            </p>
            
            <div className="flex space-x-5">
              <a href="#" className="text-white text-xs hover:text-blue-400 transition-colors cursor-pointer font-light">
                Privacy Policy
              </a>
              <a href="#" className="text-white text-xs hover:text-blue-400 transition-colors cursor-pointer font-light">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}